import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaTwitter } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import sanityClient from '../../client';
// import WhiteLogo from "../../assets/gt-home logo white.svg"
import WhiteLogo from "../../assets/logo.svg";

function FooterEn() {
  let year = new Date().getFullYear();
  const [social, setSocial] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type=="home"]{
      social
    }`;
    sanityClient
      .fetch(query)
      .then((data) => {
        setSocial(data[0].social);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (loading) {
    return (
      <div>
        <h1>Loading ...</h1>
      </div>
    );
  }

  return (
    <div className="footer" style={{ direction: "rtl" }}>
      <div className="top">
        <div className="logo">
          <img src={WhiteLogo} className="app-logo" alt="logo" />
        </div>
        <div className="links">
          <Link to="/ar">الرئيسية</Link>
          <Link to="/ar/projects">المشاريع</Link>
          <Link to="/ar/properties">العقارات</Link>
          <Link to="/ar/contact">اتصال</Link>
        </div>
        <div className="social">
          <div className="logos">
            <a target="_blank" rel="noreferrer" href={social.facebook}>
              <FaFacebookF />
            </a>
            <a target="_blank" rel="noreferrer" href={social.instagram}>
              <FaInstagram />
            </a>
            <a target="_blank" rel="noreferrer" href={social.twitter}>
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
      <div className="bottom">Copyright &copy; Company Name {year}</div>
    </div>
  );
}

export default FooterEn;
